import { WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { FdMeasurementApplication } from '../../types';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  let isGroundInvestigationTests = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.MeasurementApplication'),
      (d) => d === FdMeasurementApplication.ComparativeTests || d === FdMeasurementApplication.AbsoluteTests
    )
  );

  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.InsituMoistureContent" label="Moisture Content (%)" />
        <Field input={<TextOutput />} name="Results.InsituDryDensity" />

        {!isGroundInvestigationTests && (
          <>
            <Field input={<TextOutput />} name="Results.MaximumDryDensity" />
            <Field input={<TextOutput />} name="Results.OptimumMoistureContent" />
            <Field input={<TextOutput />} name="Results.RelativeCompaction" />
            <Field input={<TextOutput />} name="Results.InsituAirVoids" />
          </>
        )}
      </ListFieldSection>
      <ListFieldSection heading="Report" visible={!isGroundInvestigationTests}>
        <Field input={<RadioGroup />} name="Results.ReportResultsOption" />
      </ListFieldSection>
    </>
  );
};

const BsResultsSection = withInjectedProps(Section);

export { BsResultsSection };
export default BsResultsSection;
